import { ApiResponse } from './api-response';
import { Vehicle } from './vehicles';

export interface GetPersonUser {
	identityKitUser: IdentityKitUser;
	portalUser: ApiResponse<PortalPersonStatus>;
}

export interface IdentityKitUser {
	identityKitId: string | null;
	email: string | null;
	firstName: string | null;
	lastName: string | null;
	salutation: string | null;
	academicTitle: string | null;
	phoneNumbers: PhoneNumber[] | null;
}

export interface PhoneNumber {
	uuid: string;
	type: string;
	number: string;
	primary: boolean;
	_updated: Date | string;
}

export interface PortalPersonStatus {
	identitykitId: string | null;
	climapro: ClimaproData;
	clubVW: ClubvwData;
	dealers: {
		pv: Dealers;
	};
}

export enum UserStatus {
	OK = 'OK',
	PREMATCH = 'PREMATCH',
	PENDING = 'PENDING',
	KO = 'KO',
	ANONYMOUS = 'ANONYMOUS',
	ERROR = 'ERROR',
}

export interface ClimaproData {
	climaproId: number;
	status: UserStatus;
	email: string;
	firstSurname: string;
	name: string;
	secondSurname: string;
}

export interface ClubvwData {
	fechaAltaClub: string;
	fechaBajaClub: string;
	fechaAltaNotificaciones: string;
	fechaBajaNotificaciones: string;
	notificaciones: boolean;
	idMember: string;
	status: clubStatus;
	isAccepted: boolean;
}

export interface Dealers {
	id?: number;
	installationCode?: string;
	brandCode?: string;
	kvpsCode?: string;
	commercialName?: string;
	bussinesName?: string;
	flagVn?: boolean;
	preregistredDateVn?: number;
	registredDateVn?: number;
	precancelatedDateVn?: number;
	cancelatedDateVn?: number;
	emailVn?: string;
	phoneVn?: string;
	directionDescriptionVn?: string;
	postalCodeVn?: string;
	locationDescriptionVn?: string;
	provinceVn?: DealersProvince;
	latitudeVn?: number;
	longitudeVn?: number;
	scheduleNoteDescriptionVn?: string;
	flagPv?: boolean;
	preregistredDatePv?: number;
	registredDatePv?: number;
	precancelatedDatePv?: number;
	cancelatedDatePv?: number;
	phonePv?: string;
	directionDescriptionPv?: string;
	postalCodePv?: string;
	locationDescriptionPv?: string;
	provincePv?: DealersProvince;
	latitudePv?: number;
	longitudePv?: number;
	scheduleNoteDescriptionPv?: string;
	flagAs?: boolean;
	preregistredDateAs?: number;
	registredDateAs?: number;
	precancelatedDateAs?: number;
	cancelatedDateAs?: number;
	emailAs?: string;
	phoneAs?: string;
	directionDescriptionAs?: string;
	postalCodeAs?: string;
	locationDescriptionAs?: string;
	provinceAs?: DealersProvince;
	latitudeAs?: number;
	longitudeAs?: number;
	scheduleNoteDescriptionAs?: string;
	services: DealersServices;
}

interface DealersProvince {
	id?: number;
	provinceCode?: string;
	provinceCodeShort?: String;
	provinceDesc?: String;
	regionCode?: String;
	regionDesc?: String;
}

interface DealersServices {
	recogidaEntrega: boolean;
	cocheSustitucion: boolean;
	expressService: boolean;
	autoservicio: boolean;
	ITVporTi: boolean;
}

export enum clubStatus {
	MEMBER = 'MEMBER',
	NOT_MEMBER = 'NOT_MEMBER',
	FORMER_MEMBER = 'FORMER_MEMBER',
}

export interface CreatePerson {
	personalData: PersonalData;
	clubVWData: clubVWData;
}
export interface AcceptPerson {
	clubVWData: clubVWData;
}

export interface ConsentsPerson {
	notificaciones: boolean;
}

export interface PersonalData {
	name: string;
	firstSurname: string;
	secondSurname: string;
	documentType: any; //TypeDocumentEnum;
	documentValue: string;
	email: string;
	identitykitId?: string;
}

interface clubVWData {
	perfiladoComercial: string;
	originDeviceType: string;
	originTrackingCode: string;
	formUrl: string;
}

export interface AppointmentDataPortal {
	featureApp: string;
	dealer?: string | null;
	vehicle: Vehicle[] | null;
	motivo: 'PREITV';
}
